import React, { Component } from 'react'
import { Row, Col, Button, Container } from 'react-bootstrap';
import * as Cookies from "es-cookie";
import { components } from 'react-select';
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import './_offlineExams.scss';
import moment from 'moment';


class ExcelContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }


  render() {


    console.log("props", this.props);
    return (
      <>
        <ReactHTMLTableToExcel
          id="test-table-xls-button"
          className="btn text-uppercase  downlaod_btn download_btn_color"
          table="table-to-xls"
          filename="Student_exam_report"
          sheet="Student_exam_report"
          buttonText="DOWNLOAD REPORT"
        />
        <table id="table-to-xls" style={{ display: "none" }} >
          <thead>
            <tr>
              <th style={{ color: "#000", textAlign: "center", fontSize: "15px", fontWeight: "bold" }} rowSpan="2" key="studentName">Student Name</th>
              <th style={{ color: "#000", textAlign: "center", fontSize: "15px", fontWeight: "bold" }} rowSpan="2" key="roll_no">Roll No</th>
              <th style={{ color: "#000", textAlign: "center", fontSize: "15px", fontWeight: "bold" }} rowSpan="2" key="branch">Branch</th>
              <th style={{ color: "#000", textAlign: "center", fontSize: "15px", fontWeight: "bold" }} rowSpan="2" key="section">Section</th>
              {this.props.getOffExamResults.length > 0 ? (
                Object.keys(this.props.getOffExamResults[0]).map((key) => {
                  if (key !== 'student_name' &&  key !== 'roll_no' && key !== 'branch_name' && key !== 'section_name') {
                    return (
                      <th key={key} style={{ color: "#000", width: "100px", fontSize: "15px" }} colSpan={Object.keys(this.props.getOffExamResults[0][key]).length}>
                        {key}
                      </th>
                    );
                  }
                  return null; // Include this line to handle the case when key is 'student_name' or 'branch_name'
                })
              ) : (
                ""
              )}
            </tr>
            <tr>
              {this.props.getOffExamResults.length > 0 ? (
                Object.keys(this.props.getOffExamResults[0]).map((key) => {
                  if (key !== 'student_name'  && key !== 'roll_no' && key !== 'branch_name' && key !== 'section_name') {
                    return Object.keys(this.props.getOffExamResults[0][key]).map((item) => (
                      <th key={item} style={{ color: "#000", width: "100px", fontSize: "15px" }} rowSpan="1">
                        {item.replace("_", " ")}
                      </th>
                    ));
                  }
                  return null;
                })
              ) : (
                ""
              )}
            </tr>
          </thead>

          <tbody>
            {this.props.getOffExamResults.map((item) => (
              <tr key={item.student_name}>
                <td style={{ textAlign: "center", fontSize: "15px" }}>{item.student_name}</td>
                <td style={{ textAlign: "center", fontSize: "15px" }}>{item.roll_no}</td>
                <td style={{ textAlign: "center", fontSize: "15px" }}>{item.branch_name}</td>
                <td style={{ textAlign: "center", fontSize: "15px" }}>{item.section_name}</td>
                {this.props.getOffExamResults.length > 0 ? (
                  Object.keys(item).map((key) => {
                    if (key !== 'student_name' && key !== 'roll_no' && key !== 'branch_name' && key !== 'section_name') {
                      return Object.values(item[key]).map((item1, index) => (
                        <td key={index} style={{ textAlign: "center", fontSize: "15px" }}>
                          {item1}
                        </td>
                      ));
                    }
                    return null;
                  })
                ) : (
                  ""
                )}
              </tr>
            ))}
          </tbody>

        </table>

      </>
    )
  }
}

export default ExcelContainer;



